// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"c11d1bd7","453":"ed5deb51"}[chunkId] + ".chunk.js";
};